import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Wed Oct 31 2018
 * @author SKu
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import { observer } from 'mobx-react';
import * as React from 'react';
import { CONSTANTS } from '../../../constants';
import rootStore from '../../../shared/stores/RootStore';
import { StoreName } from '../../../shared/stores/StoreName';
import translate from '../../i18n/translate';

var Title =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Title, _React$Component);

  function Title() {
    var _this;

    _classCallCheck(this, Title);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Title).apply(this, arguments));
    _this.pageInfoStore = rootStore.getStore(StoreName.PageInfo);
    return _this;
  }

  _createClass(Title, [{
    key: "render",
    value: function render() {
      return React.createElement(React.Fragment, null, React.createElement("div", {
        className: "header-title"
      }, React.createElement("h1", null, this.pageInfoStore.title)), this.props.appSwitchEnabled ? React.createElement("div", {
        className: "header-dark header-switch header-apps"
      }, React.createElement("span", {
        className: "mr1"
      }, CONSTANTS.APP.NAME === 'pricing' ? translate('pricing-title') : translate('promo-title')), React.createElement("svg", {
        width: "10",
        height: "10",
        viewBox: "0 0 1792 1792",
        xmlns: "http://www.w3.org/2000/svg"
      }, React.createElement("path", {
        d: "M1683 808l-742 741q-19 19-45 19t-45-19l-742-741q-19-19-19-45.5t19-45.5l166-165q19-19 45-19t45 19l531 531 531-531q19-19 45-19t45 19l166 165q19 19 19 45.5t-19 45.5z"
      })), React.createElement("div", {
        className: "header-switch-menu"
      }, React.createElement("a", {
        href: CONSTANTS.APP.NAME === 'pricing' ? CONSTANTS.APP.PROMO_HOST : CONSTANTS.APP.PRICING_HOST
      }, CONSTANTS.APP.NAME === 'pricing' ? translate('promo-title') : translate('pricing-title')), React.createElement("a", {
        href: this.props.appLive && CONSTANTS.APP.PPM_HOST ? CONSTANTS.APP.PPM_HOST : ''
      }, translate('ppm-title')), React.createElement("a", {
        href: this.props.appLive && CONSTANTS.APP.STORE_REPLE_HOST ? CONSTANTS.APP.STORE_REPLE_HOST : ''
      }, translate('store-replenishment-title')), React.createElement("a", {
        href: this.props.appLive && CONSTANTS.APP.DC_REPLE_HOST ? CONSTANTS.APP.DC_REPLE_HOST : ''
      }, translate('dc-replenishment-title')))) : null);
    }
  }]);

  return Title;
}(React.Component);

Title = __decorate([observer], Title);
export { Title };